export const paymentLinkTableHeader = [
  { label: "Date Created", cellWidth: "226px" },
  { label: "Total No Of Products", cellWidth: "228px" },
  { label: "Short Code", cellWidth: "130px" },
  { label: "Actions", cellWidth: "154px" },
];

export const transactionTableHeader = [
  { label: "Payment Date", cellWidth: "275px" },
  { label: "Description", cellWidth: "170px" },
  { label: "Amount", cellWidth: "120px" },
  { label: "Payment Type", cellWidth: "180px" },
  { label: "Transaction ID", cellWidth: "330px" },
  { label: "Status", cellWidth: "95px" },
];

export interface TableBodyItem {
  dateCreated: string;
  productName: string;
  amount: string;
  status: string;
  qRCode: string;
  button1: string;
  button2: string;
}

export const paymentLinkTableHeaderMobile = [
  { label: "Date Created", cellWidth: "226px" },
  { label: "Total No Of Products", cellWidth: "228px" },
  { label: "Short Code", cellWidth: "130px" },
  { label: "Actions", cellWidth: "154px" },
  { label: "", cellWidth: "160px" },
  { label: "", cellWidth: "57px" },
];

export const TableBodyData: TableBodyItem[] = [
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "d20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
];
